let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("h8Jkc")).then(() => parcelRequire('vKBfH'));